import { FileIcon, Sparkles, CheckCircle2, Loader2 } from "lucide-react";

export type ActividadStep = "upload" | "evaluating" | "feedback" | "chat";

interface ActividadStepperProps {
  currentStep: ActividadStep;
  hasError: boolean;
}

const STEPS = [
  {
    num: 1,
    key: "upload" as const,
    icon: <FileIcon size={22} />,
    title: "Subir archivo",
    description: "Sube tu evidencia o reto",
  },
  {
    num: 2,
    key: "evaluating" as const,
    icon: <Sparkles size={22} />,
    title: "Análisis de IA",
    description: "Procesando con inteligencia artificial",
  },
  {
    num: 3,
    key: "feedback" as const,
    icon: <CheckCircle2 size={22} />,
    title: "Acción",
    description: "Retroalimentación lista",
  },
] as const;

const STEP_ORDER: Record<ActividadStep, number> = {
  upload: 1,
  evaluating: 2,
  feedback: 3,
  chat: 3,
};

export function ActividadStepper({ currentStep, hasError }: ActividadStepperProps) {
  const activeNum = hasError ? 1 : STEP_ORDER[currentStep];

  return (
    <div className="mt-8 grid grid-cols-3 gap-3 px-2 relative z-0">
      {STEPS.map((step) => {
        const isActive = activeNum === step.num;
        const isDone = activeNum > step.num;

        return (
          <div
            key={step.num}
            style={
              isActive
                ? {
                    boxShadow:
                      "0 8px 24px -4px color-mix(in srgb, var(--primary) 35%, transparent)",
                  }
                : undefined
            }
            className={`relative flex flex-col items-center gap-2 rounded-2xl border px-3 py-4 text-center transition-all duration-500 ${
              isActive
                ? "border-[var(--primary)] bg-muted scale-105"
                : isDone
                  ? "border-[var(--primary)] bg-muted opacity-60"
                  : "border-gray-200 bg-white/50 opacity-40"
            }`}
          >
            {step.num < 3 && (
              <span
                className={`absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-0.5 z-10 transition-colors duration-500 ${
                  isDone || isActive
                    ? "bg-[var(--primary)]"
                    : "bg-gray-200"
                }`}
              />
            )}
            <div
              className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-500 ${
                isActive
                  ? "bg-[var(--primary)] text-white"
                  : isDone
                    ? "bg-[var(--primary)] text-white"
                    : "bg-gray-100 text-gray-400"
              }`}
            >
              {isActive && step.key === "evaluating" ? (
                <Loader2 size={22} className="animate-spin" />
              ) : (
                step.icon
              )}
            </div>
            <p className="text-xs font-semibold text-gray-800 dark:text-gray-200 leading-tight">
              {step.title}
            </p>
            <p className="hidden sm:block text-[11px] text-gray-500 leading-snug">
              {step.description}
            </p>
          </div>
        );
      })}
    </div>
  );
}
